export default {
  name: 'App',
  data() {
    return {
      title: 'Privacy Policy Kang Pisman',
    };
  },
  methods: {

  },
};
